import React from 'react';
import { BiSolidBot } from 'react-icons/bi';
import { colors } from '../../../colors';
import { FaUserTie, FaFileAlt } from 'react-icons/fa';

const Bots = () => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(6, 50px)',
        gridTemplateColumns: '120px 200px 400px 200px 1fr',
        gridRowGap: 12,
        marginTop: 32,
      }}
    >
      {/** Users */}
      <div
        style={{
          gridArea: '2 / 1 / 2 / 1',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/** User 1 */}
        <FaUserTie color={colors.white} size={32} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>User 1</span>
      </div>
      <div
        style={{
          gridArea: '5 / 1 / 5 / 1',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/** User 2 */}
        <FaUserTie color={colors.white} size={32} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>User 2</span>
      </div>
      {/** Subscriptions */}
      <div
        style={{
          gridArea: '1 / 3 / 1 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid white',
          borderRadius: 8,
        }}
      >
        {/** Subscription 1 */}
        <FaFileAlt color={colors.white} size={22} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>
          Subscription 1 | Binance | USDC
        </span>
      </div>
      <div
        style={{
          gridArea: '2 / 3 / 2 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid white',
          borderRadius: 8,
        }}
      >
        {/** Subscription 2 */}
        <FaFileAlt color={colors.white} size={22} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>
          Subscription 2 | KuCoin | USDT
        </span>
      </div>
      <div
        style={{
          gridArea: '3 / 3 / 3 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid white',
          borderRadius: 8,
        }}
      >
        {/** Subscription 3 */}
        <FaFileAlt color={colors.white} size={22} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>
          Subscription 3 | Coinbase | USDC
        </span>
      </div>
      <div
        style={{
          gridArea: '4 / 3 / 4 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid white',
          borderRadius: 8,
        }}
      >
        {/** Subscription 4 */}
        <FaFileAlt color={colors.white} size={22} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>
          Subscription 4 | Binance | USDC
        </span>
      </div>
      <div
        style={{
          gridArea: '5 / 3 / 5 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid white',
          borderRadius: 8,
        }}
      >
        {/** Subscription 5 */}
        <FaFileAlt color={colors.white} size={22} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>
          Subscription 5 | KuCoin | USDT
        </span>
      </div>
      <div
        style={{
          gridArea: '6 / 3 / 6 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid white',
          borderRadius: 8,
        }}
      >
        {/** Subscription 6 */}
        <FaFileAlt color={colors.white} size={22} />
        <span style={{ marginLeft: 10, fontSize: 22 }}>
          Subscription 6 | Coinbase | USDC
        </span>
      </div>
      {/** Bots */}
      <div
        style={{
          gridArea: '1 / 5 / 4 / 5',
          display: 'flex',
          alignItems: 'center',
          marginLeft: 20,
        }}
      >
        {/** Bot 1 */}
        <BiSolidBot color={colors.white} size={32} />
        <span style={{ marginLeft: 10, marginTop: 3, fontSize: 22 }}>
          Bitcoin Bot
        </span>
      </div>
      <div
        style={{
          gridArea: '4 / 5 / 6 / 5',
          display: 'flex',
          alignItems: 'center',
          marginLeft: 20,
        }}
      >
        {/** Bot 2 */}
        <BiSolidBot color={colors.white} size={32} />
        <span style={{ marginLeft: 10, marginTop: 3, fontSize: 22 }}>
          Ethereum Bot
        </span>
      </div>
      <div
        style={{
          gridArea: '6 / 5 / 7 / 5',
          display: 'flex',
          alignItems: 'center',
          marginLeft: 20,
        }}
      >
        {/** Bot 3 */}
        <BiSolidBot color={colors.white} size={32} />
        <span style={{ marginLeft: 10, marginTop: 3, fontSize: 22 }}>
          Fartcoin Bot
        </span>
      </div>
      {/** Bot Lines */}
      <div
        style={{
          gridArea: '1 / 4 / 3 / 4',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '2 / 4 / 3 / 4',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '2 / 4 / 4 / 4',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="87"
            x2="100%"
            y2="calc(100% - 87px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '4 / 4 / 6 / 4',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="87"
            x2="100%"
            y2="calc(100% - 50px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '4 / 4 / 6 / 4',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 50px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '6 / 4 / 7 / 4',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      {/** User Lines */}
      <div
        style={{
          gridArea: '1 / 2 / 3 / 2',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="87"
            x2="100%"
            y2="calc(100% - 87px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '2 / 2 / 3 / 2',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '2 / 2 / 5 / 2',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '3 / 2 / 6 / 2',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="148"
            x2="100%"
            y2="calc(100% - 148px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '5 / 2 / 6 / 2',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        style={{
          gridArea: '5 / 2 / 7 / 2',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <svg
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          <line
            x1="0"
            y1="25"
            x2="100%"
            y2="calc(100% - 25px)"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      </div>
    </div>
  );
};

export default Bots;

// 2 users, 6 subscriptions, 3 bots

{
  /* <BiSolidBot color={colors.white} />
      <FaUserTie color={colors.white} />
      <FaFileAlt color={colors.white} /> */
}
